import { fetchRequest } from "@providers/conect";

const bulkCreateServiciosApi = async ( data ) => {
  try {
    const url = `servicios/bulk-create`
    const response = await fetchRequest(url, {
      method: "POST",
      body:{
        data: data
      }
    });
    return response;
  } catch (error) {
    throw error;
  }
};

const getAllServiciosApi = async (data) => {
  try {
    const url = `servicios/all`
    const response = await fetchRequest(url, {
      method: "POST",
      body:{
        data
      }
    });
    return response;
  } catch (error) {
    throw error;
  }  
};

const searchServiciosApi = async ( data ) => {
  try {
    const url = `servicios/search`
    const response = await fetchRequest(url, {
      method: "POST",
      body: data
    });
    return response;
  } catch (error) {
    throw error;
  }
};

const updateServicioApi = async (id, data) => {
  try {
    const url = `servicios/update/${id}`
    const response = await fetchRequest(url, {
      method: "PUT",
      body: data
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export { bulkCreateServiciosApi, getAllServiciosApi, searchServiciosApi, updateServicioApi };
